export default __webpack_public_path__ + "static/media/DMA.a1603d71.jfif";